import React, { useEffect, useRef, useState } from 'react'
import {
  MdDarkMode,
  MdLightMode,
  MdTableChart,
  MdHourglassEmpty,
  MdFactCheck,
  MdOutlineAdminPanelSettings,
  MdSettings,
} from 'react-icons/md'
import {
  FaBars,
  FaChevronLeft,
  FaChevronRight,
  FaChevronUp,
  FaChevronDown,
  FaStore,
} from 'react-icons/fa6'
import { FaGlobeAmericas, FaBoxes } from 'react-icons/fa'
import { TbDoorExit } from 'react-icons/tb'
import { HiDocumentArrowDown } from 'react-icons/hi2'
import ValidacaoSellout from '../../view/ValidacaoSellout'
import SkuAnalyticsScreen from '../../view/SkuAnalyticsScreen'

import {
  HeaderWrapper,
  MainTab,
  MobileMenuContainer,
  NavButton,
  FilterBackdrop,
  FilterModal,
  WebMenuContainer,
  WebNavButton,
  ExpandedMenu,
  AppMainLayout,
  VerticalSidebar,
  SidebarUserSection,
  SidebarUserDropdown,
  HorizontalUserSection,
  HorizontalUserDropdown,
  SidebarFilterSection,
  VerticalNavButton,
  ContentArea,
} from './styles'
import { Link } from 'react-router-dom'
import { HeaderLogo, HeaderMain } from '../Header/styles'
import { FaFileContract, FaFilter } from 'react-icons/fa6'

import { cancelAllPendingRequests } from '../../services/axios'
import MonthSelectorCalendar from '../Filters/MonthFilter'
import EstoqueScreen from '../../view/EstoqueScreen'
import GeralScreen from '../../view/GeralScreen'
import GeralFilterBar from '../Filters/GeralFilter'
import ClientMapScreen from '../../view/ClienteMapScreen'
import RankedCoverage from '../../view/RankedCoverage'
import RegularView from '../../view/RegularView'
import { BsInfoCircleFill, BsUiChecksGrid, BsStars } from 'react-icons/bs'
import { FaTimes } from 'react-icons/fa'
import { FiDatabase, FiFolder, FiKey } from 'react-icons/fi'
import { PiWarningDiamondFill, PiBowlFoodBold } from 'react-icons/pi'
import { ClientAlert } from '../../view/ClientAlert'
import RankingFiltroBar from '../Filters/ClienteAlertFilter'
import { useCustomTheme } from '../../context/Theme/ThemeContextData'
import RelatorioVendas from '../../view/RelatorioScreen'
import UserList from '../../view/UserList'
import EstoqueFilterBar from '../Filters/EstoqueFilter'
import PendingFilesView from '../../view/PendingFilesView'
import FileLogsView from '../../view/FileLogsView'
import IntegrationsHub from '../../view/IntegrationsHub'
import { GidIaIcon } from '../GisaAssistant/GidIaIcon'
import { useAuth } from '../../context/AuthContext'
import ModalUserSettings from '../Modals/ModalUserSettings'
import ModalWelcomeUpdate from '../Modals/ModalWelcomeUpdate'

export default function MobileMenu() {
  const [pages, setPages] = useState(0)
  const [lastDashboardPage, setLastDashboardPage] = useState(0)
  const [welcomeModalOpen, setWelcomeModalOpen] = useState(() => {
    const hasSeen = localStorage.getItem('@GID:seen_update_modal_1.3')
    return !hasSeen
  })
  const [modal, setModal] = useState(false)
  const [modalFilter, setModalFilter] = useState(false)
  const [userMenuOpen, setUserMenuOpen] = useState(false)
  const headerRef = useRef<HTMLDivElement>(null)
  const filterModalRef = useRef<HTMLDivElement>(null)
  const userMenuRef = useRef<HTMLDivElement>(null)
  const horizontalUserRef = useRef<HTMLDivElement>(null)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [hideHeader, setHideHeader] = useState(false)
  const [userSettingsOpen, setUserSettingsOpen] = useState(false)
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)

  const { theme, toggleTheme, menuOrientation, menuHighlight } = useCustomTheme()
  const { user, signOut } = useAuth()

  const nickname = user?.nickname || ''
  const useRole = user?.role || ''

  // Paleta de cores vibrantes para destaque misto por ferramenta
  const itemColors: Record<number, string> = {
    0: '#38bdf8', // Geral (Azul Céu)
    1: '#a855f7', // Regularidade (Roxo)
    2: '#f97316', // Estoque (Laranja)
    3: '#ec4899', // Faseamento (Rosa)
    11: '#10b981', // Sellout (Verde Esmeralda)
    4: '#eab308', // Ranking UF (Amarelo Ouro)
    5: '#f43f5e', // Acompanhamento de Giro (Vermelho Rosa)
    13: '#06b6d4', // Média de SKU (Ciano)
    8: '#6366f1', // Relatório (Índigo)
    12: '#14b8a6', // Monitor de Arquivos (Verde Água)
    10: '#8b5cf6', // Base de Dados (Violeta)
    9: '#f59e0b', // Controle de usuários (Âmbar)
    14: '#10b981', // Integrações & IA GISA (Esmeralda)
  }

  const getItemColor = (id: number) => {
    if (menuHighlight === 'green') return '#a6c10b'
    return itemColors[id] || '#a6c10b'
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement | null

      if (
        modal &&
        horizontalUserRef.current &&
        !horizontalUserRef.current.contains(target as Node)
      ) {
        setModal(false)
      }

      if (userMenuOpen && userMenuRef.current && !userMenuRef.current.contains(target as Node)) {
        setUserMenuOpen(false)
      }

      if (modalFilter) {
        const isInsideFilterModal =
          filterModalRef.current && filterModalRef.current.contains(target as Node)
        const isInsidePortal = target?.closest?.(
          '.react-select-containe__menu, .select-react-select-containe__menu, [class*="react-select"]',
        )
        const isTriggerButton = target?.closest?.('.filter, .sidebar-filter-btn')

        if (!isInsideFilterModal && !isInsidePortal && !isTriggerButton) {
          setModalFilter(false)
        }
      }
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setModalFilter(false)
        setModal(false)
        setUserMenuOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [modal, modalFilter, userMenuOpen])

  const handleLogout = async () => {
    await signOut()
  }

  const handleSelectPage = (pageIndex: number) => {
    if (pages !== pageIndex) {
      cancelAllPendingRequests()
      if (pageIndex !== 14) {
        setLastDashboardPage(pageIndex)
      }
      setPages(pageIndex)
      setHideHeader(false)
      setModalFilter(false)
      setIsMenuOpen(false)
      window.dispatchEvent(new CustomEvent('gid:page-changed', { detail: { pageId: pageIndex } }))
    }
  }

  useEffect(() => {
    const handleNavigateFromGisa = (ev: any) => {
      if (typeof ev?.detail?.pageId === 'number') {
        handleSelectPage(ev.detail.pageId)
      }
    }
    window.addEventListener('gid:navigate-page', handleNavigateFromGisa as EventListener)
    return () => {
      window.removeEventListener('gid:navigate-page', handleNavigateFromGisa as EventListener)
    }
  }, [pages])

  const hasFilter = [0, 1, 2, 3, 4, 13].includes(pages)
  const isVertical = menuOrientation === 'vertical'
  const isIntegrationsFullPage = pages === 14

  return (
    <AppMainLayout $isVertical={isVertical && !isIntegrationsFullPage}>
      {/* Sidebar Lateral para Layout Vertical */}
      {isVertical && !isIntegrationsFullPage && (
        <VerticalSidebar $collapsed={sidebarCollapsed}>
          <div className='sidebar-header-toggle'>
            <button
              className='collapse-btn'
              onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
              title={sidebarCollapsed ? 'Expandir barra lateral' : 'Recolher barra lateral'}
            >
              {sidebarCollapsed ? <FaChevronRight size={14} /> : <FaChevronLeft size={14} />}
            </button>
          </div>

          {/* Botão de Filtro integrado na barra lateral se a tela tiver filtros */}
          {hasFilter && (
            <SidebarFilterSection $collapsed={sidebarCollapsed}>
              <button
                type='button'
                className='sidebar-filter-btn'
                onClick={() => setModalFilter(true)}
                title='Abrir Filtros da Página'
              >
                <FaFilter size={16} />
                <span>Filtros</span>
              </button>
            </SidebarFilterSection>
          )}

          {/* Lista de navegação vertical */}
          <div className='sidebar-nav-list'>
            <VerticalNavButton
              $active={pages === 0}
              $highlightColor={getItemColor(0)}
              $collapsed={sidebarCollapsed}
              onClick={() => handleSelectPage(0)}
              title='Geral'
            >
              <div className='icon-wrap'>
                <FaGlobeAmericas />
              </div>
              <span>Geral</span>
            </VerticalNavButton>

            <VerticalNavButton
              $active={pages === 1}
              $highlightColor={getItemColor(1)}
              $collapsed={sidebarCollapsed}
              onClick={() => handleSelectPage(1)}
              title='Regularidade'
            >
              <div className='icon-wrap'>
                <BsUiChecksGrid />
              </div>
              <span>Regularidade</span>
            </VerticalNavButton>

            <VerticalNavButton
              $active={pages === 2}
              $highlightColor={getItemColor(2)}
              $collapsed={sidebarCollapsed}
              onClick={() => handleSelectPage(2)}
              title='Estoque'
            >
              <div className='icon-wrap'>
                <FaBoxes />
              </div>
              <span>Estoque</span>
            </VerticalNavButton>

            <VerticalNavButton
              $active={pages === 3}
              $highlightColor={getItemColor(3)}
              $collapsed={sidebarCollapsed}
              onClick={() => handleSelectPage(3)}
              title='Faseamento'
            >
              <div className='icon-wrap'>
                <MdTableChart />
              </div>
              <span>Faseamento</span>
            </VerticalNavButton>

            <VerticalNavButton
              $active={pages === 11}
              $highlightColor={getItemColor(11)}
              $collapsed={sidebarCollapsed}
              onClick={() => handleSelectPage(11)}
              title='Sellout'
            >
              <div className='icon-wrap'>
                <MdFactCheck />
              </div>
              <span>Sellout</span>
            </VerticalNavButton>

            {useRole !== 'gestor' && (
              <VerticalNavButton
                $active={pages === 4}
                $highlightColor={getItemColor(4)}
                $collapsed={sidebarCollapsed}
                onClick={() => handleSelectPage(4)}
                title='PDVs'
              >
                <div className='icon-wrap'>
                  <FaStore />
                </div>
                <span>PDVs</span>
              </VerticalNavButton>
            )}

            <VerticalNavButton
              $active={pages === 13}
              $highlightColor={getItemColor(13)}
              $collapsed={sidebarCollapsed}
              onClick={() => handleSelectPage(13)}
              title='SKU'
            >
              <div className='icon-wrap'>
                <PiBowlFoodBold />
              </div>
              <span>SKU</span>
            </VerticalNavButton>

            {useRole !== 'gestor' && useRole !== 'visualizador' && (
              <VerticalNavButton
                $active={pages === 8}
                $highlightColor={getItemColor(8)}
                $collapsed={sidebarCollapsed}
                onClick={() => handleSelectPage(8)}
                title='Relatório'
              >
                <div className='icon-wrap'>
                  <HiDocumentArrowDown />
                </div>
                <span>Relatório</span>
              </VerticalNavButton>
            )}

            {useRole === 'administrador' && (
              <>
                <VerticalNavButton
                  $active={pages === 12}
                  $highlightColor={getItemColor(12)}
                  $collapsed={sidebarCollapsed}
                  onClick={() => handleSelectPage(12)}
                  title='Monitor de Arquivos'
                >
                  <div className='icon-wrap'>
                    <FiFolder />
                  </div>
                  <span>Monitor de Arquivos</span>
                </VerticalNavButton>

                <VerticalNavButton
                  $active={pages === 10}
                  $highlightColor={getItemColor(10)}
                  $collapsed={sidebarCollapsed}
                  onClick={() => handleSelectPage(10)}
                  title='Base de Dados'
                >
                  <div className='icon-wrap'>
                    <FiDatabase />
                  </div>
                  <span>Base de Dados</span>
                </VerticalNavButton>

                <VerticalNavButton
                  $active={pages === 9}
                  $highlightColor={getItemColor(9)}
                  $collapsed={sidebarCollapsed}
                  onClick={() => handleSelectPage(9)}
                  title='Controle de usuários'
                >
                  <div className='icon-wrap'>
                    <MdOutlineAdminPanelSettings />
                  </div>
                  <span>Controle de usuários</span>
                </VerticalNavButton>
              </>
            )}
          </div>

          {/* Usuário integrado no rodapé da barra lateral com menu suspenso */}
          <SidebarUserSection ref={userMenuRef} $collapsed={sidebarCollapsed}>
            <div
              className='user-card-clickable'
              title={`${nickname} - Opções da Conta`}
              onClick={() => setUserMenuOpen(!userMenuOpen)}
            >
              <div className='avatar'>{nickname?.slice(0, 2).toUpperCase()}</div>
              {!sidebarCollapsed && (
                <>
                  <div className='user-info'>
                    <span className='nickname' title={nickname}>
                      {nickname}
                    </span>
                    <span className='role'>{useRole}</span>
                  </div>
                  <div className='chevron-indicator'>
                    <FaChevronUp
                      size={12}
                      style={{
                        transform: userMenuOpen ? 'rotate(180deg)' : 'none',
                        transition: 'transform 0.2s ease',
                      }}
                    />
                  </div>
                </>
              )}
            </div>

            {/* Menu Dropdown ao clicar no usuário */}
            {userMenuOpen && (
              <SidebarUserDropdown $collapsed={sidebarCollapsed}>
                <button
                  type='button'
                  className='dropdown-item'
                  onClick={() => {
                    toggleTheme()
                    setUserMenuOpen(false)
                  }}
                  title='Alternar Tema'
                >
                  {theme === 'dark' ? (
                    <MdLightMode size={18} style={{ color: '#facc15' }} />
                  ) : (
                    <MdDarkMode size={18} style={{ color: '#60a5fa' }} />
                  )}
                  <span>Tema {theme === 'dark' ? 'Claro' : 'Escuro'}</span>
                </button>

                <button
                  type='button'
                  className='dropdown-item'
                  onClick={() => {
                    setUserMenuOpen(false)
                    setUserSettingsOpen(true)
                  }}
                  title='Configurações do Usuário'
                >
                  <MdSettings size={18} style={{ color: '#38bdf8' }} />
                  <span>Configurações</span>
                </button>

                {['administrador', 'suporte', 'conferente'].includes(useRole.toLowerCase()) && (
                  <button
                    type='button'
                    className='dropdown-item'
                    onClick={() => {
                      setUserMenuOpen(false)
                      handleSelectPage(14)
                    }}
                    title='Central GID IA — API Keys, IA & E-mails'
                  >
                    <GidIaIcon size={18} />
                    <span>Central GID IA</span>
                  </button>
                )}

                <button
                  type='button'
                  className='dropdown-item'
                  onClick={() => {
                    setUserMenuOpen(false)
                    setWelcomeModalOpen(true)
                  }}
                  title='Guia de Boas-Vindas'
                >
                  <BsStars size={18} style={{ color: '#a6c10b' }} />
                  <span>Bem vindo</span>
                </button>

                <Link
                  to='/termos-de-uso'
                  className='dropdown-item'
                  onClick={() => setUserMenuOpen(false)}
                  title='Termos de Uso'
                >
                  <FaFileContract size={18} style={{ color: '#94a3b8' }} />
                  <span>Termos de uso</span>
                </Link>

                <Link
                  to='/sobre'
                  className='dropdown-item'
                  onClick={() => setUserMenuOpen(false)}
                  title='Sobre o GID'
                >
                  <BsInfoCircleFill size={18} style={{ color: '#94a3b8' }} />
                  <span>Sobre</span>
                </Link>

                <div className='dropdown-divider' />

                <button
                  type='button'
                  className='dropdown-item logout-action'
                  onClick={() => {
                    setUserMenuOpen(false)
                    handleLogout()
                  }}
                  title='Sair da Conta'
                >
                  <TbDoorExit size={18} style={{ color: '#ef4444' }} />
                  <span>Sair</span>
                </button>
              </SidebarUserDropdown>
            )}
          </SidebarUserSection>
        </VerticalSidebar>
      )}

      {/* Área Principal de Conteúdo */}
      <ContentArea $isVertical={isVertical && !isIntegrationsFullPage}>
        {!hideHeader && !isIntegrationsFullPage && (
          <HeaderWrapper $hideOnDesktop={isVertical}>
            <HeaderMain ref={headerRef}>
              <MainTab>
                <MobileMenuContainer $isOpen={isMenuOpen}>
                  <div className='mobile-bar'>
                    <button className='hamburger-btn' onClick={() => setIsMenuOpen(!isMenuOpen)}>
                      {isMenuOpen ? <FaTimes size={30} /> : <FaBars size={30} />}
                    </button>
                  </div>

                  <ExpandedMenu $isOpen={isMenuOpen}>
                    <div className='menu-items'>
                      <NavButton $active={pages === 0} onClick={() => handleSelectPage(0)}>
                        <p>
                          <FaGlobeAmericas />
                        </p>
                        <span>Geral</span>
                      </NavButton>
                      <NavButton $active={pages === 1} onClick={() => handleSelectPage(1)}>
                        <p>
                          <BsUiChecksGrid />
                        </p>
                        <span>Regularidade</span>
                      </NavButton>
                      <NavButton $active={pages === 2} onClick={() => handleSelectPage(2)}>
                        <p>
                          <FaBoxes />
                        </p>
                        <span>Estoque</span>
                      </NavButton>
                      <NavButton $active={pages === 3} onClick={() => handleSelectPage(3)}>
                        <p>
                          <MdTableChart />
                        </p>
                        <span>Faseamento</span>
                      </NavButton>
                      <NavButton $active={pages === 11} onClick={() => handleSelectPage(11)}>
                        <p>
                          <MdFactCheck />
                        </p>
                        <span>Sellout</span>
                      </NavButton>
                      {useRole !== 'gestor' && (
                        <NavButton $active={pages === 4} onClick={() => handleSelectPage(4)}>
                          <p>
                            <FaStore />
                          </p>
                          <span>PDVs</span>
                        </NavButton>
                      )}
                      <NavButton $active={pages === 13} onClick={() => handleSelectPage(13)}>
                        <p>
                          <PiBowlFoodBold />
                        </p>
                        <span>SKU</span>
                      </NavButton>

                      {useRole !== 'gestor' && useRole !== 'visualizador' && (
                        <NavButton $active={pages === 8} onClick={() => handleSelectPage(8)}>
                          <p>
                            <HiDocumentArrowDown />
                          </p>
                          <span>Relatório</span>
                        </NavButton>
                      )}

                      {useRole === 'administrador' && (
                        <>
                          <NavButton $active={pages === 12} onClick={() => handleSelectPage(12)}>
                            <p>
                              <FiFolder />
                            </p>
                            <span>Monitor de Arquivos</span>
                          </NavButton>
                          <NavButton $active={pages === 10} onClick={() => handleSelectPage(10)}>
                            <p>
                              <MdHourglassEmpty />
                            </p>
                            <span>Pendências</span>
                          </NavButton>
                          <NavButton $active={pages === 9} onClick={() => handleSelectPage(9)}>
                            <p>
                              <MdOutlineAdminPanelSettings />
                            </p>
                            <span>Controle de usuários</span>
                          </NavButton>
                        </>
                      )}
                    </div>
                  </ExpandedMenu>
                </MobileMenuContainer>
              </MainTab>

              <HeaderLogo
                style={{
                  position: 'relative',
                  display: 'flex',
                  width: '100%',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {/* Botão de filtro à esquerda em posição absoluta para não deslocar a cápsula central */}
                <div
                  style={{ position: 'absolute', left: 24, display: 'flex', alignItems: 'center' }}
                >
                  {hasFilter && (
                    <button
                      type='button'
                      className='filter'
                      onClick={() => setModalFilter(!modalFilter)}
                    >
                      <FaFilter style={{ color: '#ffffff', fontSize: 24 }} />
                    </button>
                  )}
                </div>

                {/* Cápsula de menus matematicamente centralizada na tela */}
                <WebMenuContainer>
                  <div className='mobile-menu'>
                    <WebNavButton
                      $active={pages === 0}
                      $highlightColor={getItemColor(0)}
                      onClick={() => handleSelectPage(0)}
                    >
                      <p>
                        <FaGlobeAmericas />
                      </p>
                      <span>Geral</span>
                    </WebNavButton>
                    <WebNavButton
                      $active={pages === 1}
                      $highlightColor={getItemColor(1)}
                      onClick={() => handleSelectPage(1)}
                    >
                      <p>
                        <BsUiChecksGrid />
                      </p>
                      <span>Regularidade</span>
                    </WebNavButton>
                    <WebNavButton
                      $active={pages === 2}
                      $highlightColor={getItemColor(2)}
                      onClick={() => handleSelectPage(2)}
                    >
                      <p>
                        <FaBoxes />
                      </p>
                      <span>Estoque</span>
                    </WebNavButton>
                    <WebNavButton
                      $active={pages === 3}
                      $highlightColor={getItemColor(3)}
                      onClick={() => handleSelectPage(3)}
                    >
                      <p>
                        <MdTableChart />
                      </p>
                      <span>Faseamento</span>
                    </WebNavButton>
                    <WebNavButton
                      $active={pages === 11}
                      $highlightColor={getItemColor(11)}
                      onClick={() => handleSelectPage(11)}
                    >
                      <p>
                        <MdFactCheck />
                      </p>
                      <span>Sellout</span>
                    </WebNavButton>
                    {useRole !== 'gestor' && (
                      <WebNavButton
                        $active={pages === 4}
                        $highlightColor={getItemColor(4)}
                        onClick={() => handleSelectPage(4)}
                      >
                        <p>
                          <FaStore />
                        </p>
                        <span>PDVs</span>
                      </WebNavButton>
                    )}

                    <WebNavButton
                      $active={pages === 13}
                      $highlightColor={getItemColor(13)}
                      onClick={() => handleSelectPage(13)}
                    >
                      <p>
                        <PiBowlFoodBold />
                      </p>
                      <span>SKU</span>
                    </WebNavButton>

                    {useRole !== 'gestor' && useRole !== 'visualizador' && (
                      <WebNavButton
                        $active={pages === 8}
                        $highlightColor={getItemColor(8)}
                        onClick={() => handleSelectPage(8)}
                      >
                        <p>
                          <HiDocumentArrowDown />
                        </p>
                        <span>Relatório</span>
                      </WebNavButton>
                    )}

                    {useRole === 'administrador' && (
                      <>
                        <WebNavButton
                          $active={pages === 12}
                          $highlightColor={getItemColor(12)}
                          onClick={() => handleSelectPage(12)}
                        >
                          <p>
                            <FiFolder />
                          </p>
                          <span>Monitor de Arquivos</span>
                        </WebNavButton>
                        <WebNavButton
                          $active={pages === 10}
                          $highlightColor={getItemColor(10)}
                          onClick={() => handleSelectPage(10)}
                        >
                          <p>
                            <FiDatabase />
                          </p>
                          <span>Base de Dados</span>
                        </WebNavButton>
                        <WebNavButton
                          $active={pages === 9}
                          $highlightColor={getItemColor(9)}
                          onClick={() => handleSelectPage(9)}
                        >
                          <p>
                            <MdOutlineAdminPanelSettings />
                          </p>
                          <span>Controle de usuários</span>
                        </WebNavButton>
                      </>
                    )}
                  </div>
                </WebMenuContainer>

                {/* Botão de usuário à direita em posição absoluta para manter a cápsula no centro exato */}
                <div
                  style={{ position: 'absolute', right: 24, display: 'flex', alignItems: 'center' }}
                >
                  <HorizontalUserSection ref={horizontalUserRef}>
                    <div
                      className='user-card-clickable'
                      title={`${nickname} - Opções da Conta`}
                      onClick={() => setModal(!modal)}
                    >
                      <div className='avatar'>{nickname?.slice(0, 2).toUpperCase()}</div>
                      <div className='user-info'>
                        <span className='nickname' title={nickname}>
                          {nickname}
                        </span>
                        <span className='role'>{useRole}</span>
                      </div>
                      <div className='chevron-indicator'>
                        <FaChevronDown
                          size={12}
                          style={{
                            transform: modal ? 'rotate(180deg)' : 'none',
                            transition: 'transform 0.2s ease',
                          }}
                        />
                      </div>
                    </div>

                    {modal && (
                      <HorizontalUserDropdown>
                        <button
                          type='button'
                          className='dropdown-item'
                          onClick={() => {
                            toggleTheme()
                            setModal(false)
                          }}
                          title='Alternar Tema'
                        >
                          {theme === 'dark' ? (
                            <MdLightMode size={18} style={{ color: '#facc15' }} />
                          ) : (
                            <MdDarkMode size={18} style={{ color: '#60a5fa' }} />
                          )}
                          <span>Tema {theme === 'dark' ? 'Claro' : 'Escuro'}</span>
                        </button>

                        <button
                          type='button'
                          className='dropdown-item'
                          onClick={() => {
                            setModal(false)
                            setUserSettingsOpen(true)
                          }}
                          title='Configurações do Usuário'
                        >
                          <MdSettings size={18} style={{ color: '#38bdf8' }} />
                          <span>Configurações</span>
                        </button>

                        {['administrador', 'suporte', 'conferente'].includes(
                          useRole.toLowerCase(),
                        ) && (
                          <button
                            type='button'
                            className='dropdown-item'
                            onClick={() => {
                              setModal(false)
                              handleSelectPage(14)
                            }}
                            title='Central GID IA — API Keys, IA & E-mails'
                          >
                            <GidIaIcon size={18} />
                            <span>Central GID IA</span>
                          </button>
                        )}

                        <button
                          type='button'
                          className='dropdown-item'
                          onClick={() => {
                            setModal(false)
                            setWelcomeModalOpen(true)
                          }}
                          title='Guia de Boas-Vindas'
                        >
                          <BsStars size={18} style={{ color: '#a6c10b' }} />
                          <span>Bem vindo</span>
                        </button>

                        <Link
                          to='/termos-de-uso'
                          className='dropdown-item'
                          onClick={() => setModal(false)}
                          title='Termos de Uso'
                        >
                          <FaFileContract size={18} style={{ color: '#94a3b8' }} />
                          <span>Termos de uso</span>
                        </Link>

                        <Link
                          to='/sobre'
                          className='dropdown-item'
                          onClick={() => setModal(false)}
                          title='Sobre o GID'
                        >
                          <BsInfoCircleFill size={18} style={{ color: '#94a3b8' }} />
                          <span>Sobre</span>
                        </Link>

                        <div className='dropdown-divider' />

                        <button
                          type='button'
                          className='dropdown-item logout-action'
                          onClick={() => {
                            setModal(false)
                            handleLogout()
                          }}
                          title='Sair da Conta'
                        >
                          <TbDoorExit size={18} style={{ color: '#ef4444' }} />
                          <span>Sair</span>
                        </button>
                      </HorizontalUserDropdown>
                    )}
                  </HorizontalUserSection>
                </div>
              </HeaderLogo>
            </HeaderMain>
          </HeaderWrapper>
        )}

        {/* Telas Dinâmicas do Ecossistema GID */}
        {(() => {
          switch (pages) {
            case 0:
              return <ClientMapScreen />
            case 1:
              return <RegularView />
            case 2:
              return <EstoqueScreen />
            case 3:
              return <GeralScreen />
            case 4:
              return <RankedCoverage />
            case 5:
              return <ClientAlert />
            case 8:
              return <RelatorioVendas />
            case 9:
              return <UserList />
            case 10:
              return <PendingFilesView />
            case 11:
              return <ValidacaoSellout onToggleHeader={setHideHeader} />
            case 12:
              return <FileLogsView />
            case 13:
              return <SkuAnalyticsScreen />
            case 14:
              return (
                <IntegrationsHub
                  onBackToPanel={() => handleSelectPage(lastDashboardPage)}
                  onOpenUserSettings={() => setUserSettingsOpen(true)}
                  onOpenWelcome={() => setWelcomeModalOpen(true)}
                />
              )
            default:
              return null
          }
        })()}
      </ContentArea>

      {/* Modal de Filtros da Aplicação */}
      {modalFilter && (
        <>
          <FilterBackdrop onClick={() => setModalFilter(false)} />
          <FilterModal ref={filterModalRef}>
            {(pages === 0 || pages === 4 || pages === 13) && (
              <GeralFilterBar closeModal={() => setModalFilter(false)} isMarketAnalysis={true} />
            )}
            {pages === 3 && (
              <GeralFilterBar closeModal={() => setModalFilter(false)} isMarketAnalysis={false} />
            )}
            {pages === 1 && <MonthSelectorCalendar closeModal={() => setModalFilter(false)} />}
            {pages === 2 && <EstoqueFilterBar closeModal={() => setModalFilter(false)} />}
          </FilterModal>
        </>
      )}

      {/* Modal de Configurações do Usuário */}
      <ModalUserSettings isOpen={userSettingsOpen} onClose={() => setUserSettingsOpen(false)} />

      {/* Modal de Boas-Vindas da Nova Atualização com Abas */}
      <ModalWelcomeUpdate
        isOpen={welcomeModalOpen}
        onClose={() => setWelcomeModalOpen(false)}
        onNavigate={handleSelectPage}
      />
    </AppMainLayout>
  )
}
